var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.canShowCart
    ? _c(
        "v-badge",
        {
          key: "1",
          staticClass: "cart-badge",
          attrs: {
            transition: "slide-x-transition",
            overlap: "",
            top: "",
            color: "red",
          },
        },
        [
          _c("span", { attrs: { slot: "badge" }, slot: "badge" }, [
            _vm._v(_vm._s(_vm.cartTotal) + " "),
          ]),
          _c(
            "v-btn",
            {
              staticClass: "ma-0 pa-0 btnCanvas",
              staticStyle: {
                background: "transparent !important",
                "pointer-events": "all",
              },
              attrs: { rounded: "", regular: "", elevation: "0" },
              on: {
                click: function ($event) {
                  _vm.profileOpen = true
                  _vm.currentTab = "tab-cart"
                },
              },
            },
            [
              _c("v-icon", { attrs: { large: "", color: "primary" } }, [
                _vm._v("shopping_cart"),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }